import script from "./RequestsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsView.vue?vue&type=script&setup=true&lang=js"

import "./RequestsView.vue?vue&type=style&index=0&id=29cefa1e&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29cefa1e"]])

export default __exports__